/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

function getAlphaNumericCharSet() {
  let numbers = "0123456789";
  let letters = "abcdefghijklmnopqrstuvwxyz";
  let alphanumericCharSet = numbers + letters;
  return alphanumericCharSet;
}

function getRandomStringUsingCrypto(length, crypto) {
  let randomString = "";
  let charset = getAlphaNumericCharSet();
  let charsLen = charset.length;
  let maxByte = 256 - (256 % charsLen);
  while (length > 0) {
    let buf = getRandomBytes(Math.ceil((length * 256) / maxByte), crypto);
    for (let i = 0; i < buf.length && length > 0; i++) {
      let randomByte = buf[i];
      if (randomByte < maxByte) {
        randomString += charset.charAt(randomByte % charsLen);
        length--;
      }
    }
  }
  return randomString;
}

function getRandomBytes(n, crypto) {
  let QUOTA = 65536;
  let randomByte = new Uint8Array(n);
  for (let i = 0; i < n; i += QUOTA) {
    crypto.getRandomValues(randomByte.subarray(i, i + Math.min(n - i, QUOTA)));
  }
  return randomByte;
}

// WARNING: Use this function only if you want to generate cryptographically secure random strings,
// don't use it for normal random values. Its better to use uuid there.
export function generateRandomString(length, global = window) {
  if (global && (global.crypto || global.msCrypto)) {
    return getRandomStringUsingCrypto(length, global.crypto || global.msCrypto);
  }

  throw new Error("Can't generate cryptographically secure random string. Aborting...");
}
